import { useFeatureEntitlement } from "@/composables/use-feature-entitlement";

/**
 * Gate for the "live_mode" feature (real-time event processing, the Live
 * navigation view and dashboards).
 *
 * The feature is gated by the live_mode *subscription entitlement* — the single
 * source of truth. The backend (`ingest_event`) rejects live events unless this
 * entitlement is active, so the UI gates on the same signal (see Billing &
 * Subscription). (The legacy `stek.live_mode_enabled` flag has been removed.)
 */
export const useLiveModeEntitlement = () => {
    const {
        isEnabled: liveModeEnabled,
        isLoading: liveModeLoading,
        unavailableReason: liveModeUnavailableReason,
    } = useFeatureEntitlement("live_mode");
    return { liveModeEnabled, liveModeLoading, liveModeUnavailableReason };
};
